import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, tap, switchMap } from "rxjs/operators";
import { SET_KEY_VALUE, DELETE_KEY_VALUE, TOGGLE_FAVORITE, EVALUATE_INTERACTION, START_EXAM, logError } from "../actions";
var mapExamData = function(examData, cbook) {
    return Object.keys(examData).map(function(k) {
        var arr = [
            parseInt(k, 10)
        ];
        if (!isNaN(examData[k].tries)) {
            arr.push(examData[k].tries);
        }
        if (examData[k].answers && examData[k].answers.length) {
            arr.push(examData[k].answers.filter(function(a) {
                return a !== 0;
            }));
        }
        if (cbook.use_credit_points) {
            arr.push([
                cbook.credit_points
            ]);
        }
        return arr;
    });
};
export default function setSuspendData(action$, state$) {
    return action$.pipe(ofType(SET_KEY_VALUE, DELETE_KEY_VALUE, TOGGLE_FAVORITE, EVALUATE_INTERACTION, START_EXAM), tap(function() {
        var suspendData = state$.value.api ? state$.value.api.getSuspendData() : {};
        if (state$.value.api) {
            state$.value.api.setSuspendData({
                f: state$.value.favorites,
                kv: state$.value.keyValueStore,
                e: mapExamData(state$.value.examData, state$.value.cbook),
                p: suspendData && suspendData.p ? suspendData.p : "0%",
                v: suspendData && suspendData.v ? suspendData.v : []
            });
        }
    }), switchMap(function() {
        return [];
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "set_suspend_data"
        }));
    }));
}
